import { render, staticRenderFns } from "./NationalPatentAuthorityList.vue?vue&type=template&id=325ed674&"
import script from "./NationalPatentAuthorityList.vue?vue&type=script&lang=js&"
export * from "./NationalPatentAuthorityList.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentAuthorityList.vue?vue&type=style&index=0&id=325ed674&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports